import { LivingEnvironmentSchema, type LivingEnvironment } from "@pushback-and-chaos/contracts";
import { ENVIRONMENT_ILLUSTRATIONS } from "../generated/environment-assets.generated.js";

export const livingKits: ReadonlyMap<string, LivingEnvironment> = new Map(ENVIRONMENT_ILLUSTRATIONS.flatMap((raw) => {
  const parsed = LivingEnvironmentSchema.safeParse(raw);
  return parsed.success ? [[parsed.data.envId, parsed.data] as const] : [];
}));

/** Which environments draw their illustrated room kit. Every environment with
 * a kit does, unless VITE_ENVIRONMENT_LAYERS says otherwise at build time:
 * `off` rolls every environment back to the composed drawing, and a
 * comma-separated list of env ids restricts the kits to those. Unset and empty
 * mean the same thing, because the Dockerfile exports an empty string when the
 * host sets nothing. Rollback changes only representation; the session tape
 * and navigation remain untouched. */
export function livingEnvironmentEnabled(envId: string): boolean {
  const raw: unknown = import.meta.env["VITE_ENVIRONMENT_LAYERS"];
  const override = typeof raw === "string" ? raw.trim() : "";
  if (override === "off") return false;
  return (override === "" || override.split(",").map((id) => id.trim()).includes(envId)) && livingKits.has(envId);
}
